import { useAtom, useAtomValue, useSetAtom } from 'jotai';
import {
  conversationsAtom,
  loadableConversationsAtom,
  selectedConversationIdAtom, 
  selectedConversationAtom,
  messagesAtom,
  conversationsLoadingAtom,
  conversationLoadingAtom,
  isSendingAtom,
  loadingMoreAtom,
  hasMoreMessagesAtom,
  oldestMessageIdAtom,
  fetchConversationsAtom,
  fetchConversationAtom,
  loadMoreMessagesAtom,
  sendMessageAtom,
  deleteConversationAtom,
  createNewConversationAtom,
  uploadImageAtom
} from '../../../atoms/v0';

/**
 * 提供聊天相关的所有状态和方法的钩子
 */
export const useChat = () => {
  // 状态 atoms
  const [conversations, setConversations] = useAtom(conversationsAtom);
  const [selectedConversationId, setSelectedConversationId] = useAtom(selectedConversationIdAtom);
  const selectedConversation = useAtomValue(selectedConversationAtom);
  const [messages, setMessages] = useAtom(messagesAtom);
  const conversationsLoadable = useAtomValue(loadableConversationsAtom);
  const [conversationsLoading, setConversationsLoading] = useAtom(conversationsLoadingAtom);
  const [conversationLoading, setConversationLoading] = useAtom(conversationLoadingAtom);
  const [isSending, setIsSending] = useAtom(isSendingAtom);
  const [loadingMore, setLoadingMore] = useAtom(loadingMoreAtom);
  const [hasMoreMessages, setHasMoreMessages] = useAtom(hasMoreMessagesAtom);
  const [oldestMessageId, setOldestMessageId] = useAtom(oldestMessageIdAtom);
  
  // Action atoms
  const fetchConversations = useSetAtom(fetchConversationsAtom);
  const fetchConversation = useSetAtom(fetchConversationAtom);
  const loadMoreMessages = useSetAtom(loadMoreMessagesAtom);
  const sendMessage = useSetAtom(sendMessageAtom);
  const deleteConversation = useSetAtom(deleteConversationAtom);
  const createNewConversation = useSetAtom(createNewConversationAtom);
  const uploadImage = useSetAtom(uploadImageAtom);

  return {
    // 状态
    conversations,
    selectedConversationId,
    setSelectedConversationId,
    selectedConversation,
    messages,
    conversationsLoadable,
    conversationsLoading,
    conversationLoading,
    isSending,
    loadingMore,
    hasMoreMessages,
    oldestMessageId,
    
    // 方法
    fetchConversations,
    fetchConversation,
    loadMoreMessages,
    sendMessage,
    deleteConversation,
    createNewConversation,
    uploadImage
  };
}; 